import { Button, Flex, PopupIcon } from '@fluentui/react-northstar';
import { useContext } from "react";
import { TeamsFxContext } from "./Context";
import "./TenantNotRegistered.css";

export default function TenantNotRegistered() {
  const { themeString } = useContext(TeamsFxContext);

  const openInAzureMarketPlaceInNewWindow = () => {
    const url = "https://azuremarketplace.microsoft.com/en/marketplace/apps/cybertwicebv1586872140395.cybergate?tab=overview"
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className={themeString === "default" ? "" : "dark"}>
      <div className="tenantnotregistered page">
        <div className="narrow page-padding">
          <Flex wrap vAlign="center">
            Your organization is not a registered CyberGate user. Please buy CyberGate through the&nbsp;
            <Button icon={<PopupIcon />} text iconPosition="after" content="Azure Marketplace"
              styles={{
                padding: '0px',
              }}
              onClick={ () => openInAzureMarketPlaceInNewWindow() }  
            />
            .
          </Flex>
        </div>
      </div>
    </div>
  )
}
